import { Reveal } from "./Reveal";

const CHEF_IMG =
  "https://images.unsplash.com/photo-1750943079462-87bad58cf43e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxjaGVmJTIwcG9ydHJhaXQlMjBmaW5lJTIwZGluaW5nJTIwcmVzdGF1cmFudCUyMGx1eHVyeSUyMHdlZGRpbmclMjB0YWJsZSUyMGJhbnF1ZXR8ZW58MHx8fHwxNzkyNzk3NTU5fDA&ixlib=rb-4.1.0&q=85";

const CREDENTIALS = [
  "Trained in two Michelin-starred kitchens in Lyon and Copenhagen",
  "Former private chef to estate households across the Northeast",
  "Twelve years composing menus for weddings, galas and boardrooms",
];

export const ChefAbout = () => (
  <section id="chef" data-testid="chef-about-section" className="overflow-hidden bg-linen py-24 sm:py-32">
    <div className="mx-auto grid max-w-7xl items-center gap-16 px-5 sm:px-8 lg:grid-cols-2">
      <Reveal className="relative mx-auto w-full max-w-md lg:max-w-none">
        <div className="spotlight absolute -inset-8 -z-0" aria-hidden="true" />
        <div className="arch-frame relative overflow-hidden border border-noir/10 shadow-[0_40px_80px_-30px_rgba(26,25,23,0.35)]">
          <img
            src={CHEF_IMG}
            alt="Chef Kasey Beaumont presenting a signature dish in a lighting spotlight"
            loading="lazy"
            data-testid="chef-portrait-image"
            className="aspect-[4/5] w-full object-cover"
          />
        </div>
        <p className="absolute -bottom-5 right-6 rounded-full border border-noir/10 bg-bone/85 px-5 py-2 font-mono text-[10px] uppercase tracking-[0.25em] text-ink-soft backdrop-blur-xl">
          The Chef — In Service
        </p>
      </Reveal>

      <div>
        <Reveal>
          <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.3em] text-ink-mute">
            About the Chef
          </p>
          <h2 className="font-serif text-3xl leading-tight tracking-tight text-noir sm:text-4xl lg:text-5xl">
            Kasey <span className="italic text-truffle">Beaumont</span>
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-8 font-serif text-xl italic leading-relaxed text-truffle sm:text-2xl">
            "I don't cater events. I compose evenings — the meal is simply
            where the architecture, the season and the guest all meet."
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 text-base leading-relaxed text-ink-soft">
            Kasey began in the pastry ateliers of Lyon before moving through
            two Michelin-starred kitchens and into private service. The
            Beaumont Table was founded on a single conviction: that a meal in
            your own home should outshine any dining room.
          </p>
        </Reveal>
        <Reveal delay={0.28}>
          <ul className="mt-8 space-y-4">
            {CREDENTIALS.map((c) => (
              <li key={c} className="flex items-start gap-3 text-sm leading-relaxed text-ink-soft">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-gold" />
                {c}
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.36}>
          <p className="mt-10 font-serif text-3xl italic text-noir/70">Kasey Beaumont</p>
        </Reveal>
      </div>
    </div>
  </section>
);
